import { formatCompanyList, getConfigName, obtenerFechaHoy } from "@helpers/funciones";
import { Link, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import useInterfaceConfig from "@hooks/useInterfaceConfig";
import useInterfaceConfigV2 from "@hooks/useInterfaceConfigV2";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";
import { TAX_SYSTEM_TYPE } from "@helpers/constantes";

interface TypeText {
  type:
    | "modalCiec"
    | "textCiec"
    | "textBuro"
    | "modalBuro"
    | "avisoTerminosTextCiec"
    | "avisoTerminosTextCiec2"
    | "avisoTerminosTextBuro"
    | "confirmAval"
    | "nipBuro"
    | "nipBuroConfirm";
}

export const CustomTextCiecBuro = ({ type }: TypeText) => {
  const theme = useTheme();
  const [company, setCompany] = useState("");
  const interfaceConfig = useInterfaceConfig();
  const application = useSelector((state: RootState) => state.register.application);
  const interfaceConfigV2 = useInterfaceConfigV2();

  useEffect(() => {
    const configName = getConfigName(window.location.href);
    setCompany(String(configName));
  }, []);

  const getTextCiec = () => {
    const companyNames = interfaceConfig?.companyNames ?? [];
    const formattedCompanies = formatCompanyList(companyNames, false);
    if (application.tax_system_type === TAX_SYSTEM_TYPE.PM.code) {
      return (
        <>
          <Typography textAlign={"center"} color={theme?.palette?.primary?.dark}>
            <span>
              <small>
                Realizaremos una evaluación que nos determinará la factibilidad de poder acceder a financiamiento. Al
                continuar, el solicitante forma una relación jurídica como cliente de {formattedCompanies} y las
                autoriza a realizar consultas y evaluar información por mecanismos digitales.
              </small>
            </span>
          </Typography>
        </>
      );
    } else {
      <></>;
    }
  };

  const getTextModalCiec = () => {
    const companyNames = interfaceConfig?.companyNames ?? [];
    const formattedCompanies = formatCompanyList(companyNames, false);

    if (application.tax_system_type === TAX_SYSTEM_TYPE.PM.code) {
      return (
        <>
          <Typography textAlign={"center"} variant="body2" color={theme?.palette?.primary?.dark}>
            Por este conducto autorizo expresamente a {formattedCompanies} para que por conducto de sus funcionarios
            facultados lleve a cabo investigaciones sobre mi comportamiento crediticio o el de la Empresa que represento
            en Dun & Bradstreet, S.A. SIC.
          </Typography>
          <Typography textAlign={"center"} variant="body2" color={theme?.palette?.primary?.dark} mt={2}>
            Así mismo, declaro que conozco la naturaleza y alcance de la información que se solicitará, del uso que{" "}
            {formattedCompanies} hará de tal información y de que ésta podrá realizar consultas periódicas de mi
            historial crediticio, consintiendo que esta autorización se encuentre vigente por un periodo de 3 años
            contados a partir de la fecha de su expedición y en todo caso durante el tiempo que mantengamos relación
            jurídica.
          </Typography>
          <Typography textAlign={"center"} variant="body2" color={theme?.palette?.primary?.dark} mt={2} mb={3}>
            Declaro bajo protesta de decir verdad ser Representante Legal de la empresa mencionada en esta autorización;
            manifestando que a la fecha de la presente autorización los poderes no me han sido revocados, ni limitados
            en forma alguna.
          </Typography>
        </>
      );
    } else {
      return (
        <>
          <Typography textAlign={"center"} variant="body2" color={theme?.palette?.primary?.dark}>
            Por este conducto autorizo expresamente a {formattedCompanies} para que por conducto de sus funcionarios{" "}
            facultados lleve a cabo investigaciones, sobre mi comportamiento crediticio en Dun & Bradstreet, S.A. SIC.
          </Typography>
          <Typography textAlign={"center"} variant="body2" color={theme?.palette?.primary?.dark} mt={2}>
            Así mismo, declaro que conozco la naturaleza y alcance de la información que se solicitará, del uso que{" "}
            {formattedCompanies} hará de tal información y de que ésta podrá realizar consultas periódicas de mi
            historial crediticio, consintiendo que esta autorización se encuentre vigente por un periodo de 3 años
            contados a partir de la fecha de su expedición y en todo caso durante el tiempo que mantengamos relación
            jurídica.
          </Typography>
        </>
      );
    }
  };

  const getTextAvisoPrivacidadTerminos = () => {
    const companyNames = interfaceConfig?.companyNames ?? [];
    const formattedCompanies = formatCompanyList(companyNames, false);

    if (application.tax_system_type === TAX_SYSTEM_TYPE.PM.code) {
      return (
        <>
          <Typography variant={"body2"} color={theme?.palette?.primary?.dark}>
            Autorizo a {formattedCompanies} a consultar mi información ante Buró Empresas.
          </Typography>
        </>
      );
    } else {
      return (
        <>
          <Typography variant={"body2"} color={theme?.palette?.primary?.dark}>
            Realizaremos una evaluación que nos determinará la factibilidad de poder acceder a financiamiento. Al
            continuar, el solicitante forma una relación jurídica como cliente de {formattedCompanies} y las autoriza a
            realizar consultas y evaluar información por mecanismos digitales.
          </Typography>
        </>
      );
    }
  };

  const getTextAvisoPrivacidadTerminos2 = () => {
    return (
      <>
        <Typography variant={"body2"} color={theme?.palette?.primary?.dark}>
          Autorizo a la consulta de mi información ante SAT bajo los{" "}
          <Link href={interfaceConfigV2?.url_terms_and_conditions} target="_blank">
            términos y condiciones
          </Link>{" "}
          y el{" "}
          <Link href={interfaceConfigV2?.url_privacy_notice} target="_blank">
            aviso de privacidad
          </Link>{" "}
        </Typography>
      </>
    );
  };

  const getTextModalBuro = (typeCompany: string) => {
    if (typeCompany === "lendia") {
      return (
        <>
          <Typography textAlign={"center"} variant="body2" color={theme.palette.primary.dark}>
            Hoy siendo {obtenerFechaHoy()}, Autoriza a Lendit Group SA de CV a consultar sus antecedentes crediticios
            por única ocasión ante las Sociedades de Información Crediticia que estime conveniente, declarando que
            conoce la naturaleza, alcance y uso que Razón Social hará de tal información.
          </Typography>
        </>
      );
    }

    if (typeCompany === "finbe") {
      return (
        <>
          <Typography textAlign={"center"} variant="body2" color={theme.palette.primary.dark}>
            Hoy siendo {obtenerFechaHoy()}, Autoriza a Financiera Bepensa SA DE CV SOFOM ER, Bepensa Leasing, SA DE CV,
            AB&C Leasing de México, SAPI DE CV y a Lendit Group SAPI de CV a consultar sus antecedentes crediticios por
            única ocasión ante las Sociedades de Información Crediticia que estime conveniente, declarando que conoce la
            naturaleza, alcance y uso que Razón Social hará de tal información.
          </Typography>
        </>
      );
    }
  };

  const getTextAvisoPrivacidadTerminosBuro = (typeCompany: string) => {
    if (typeCompany === "lendia") {
      return (
        <>
          <Typography variant={"body2"} color={theme?.palette?.primary?.dark}>
            Autorizo a Lendit group a consultar mi información ante Buró Empresas. Consulta{" "}
            <Link href={interfaceConfigV2?.url_terms_and_conditions} target="_blank">
              términos y condiciones
            </Link>{" "}
            y{" "}
            <Link href={interfaceConfigV2?.url_privacy_notice} target="_blank">
              aviso de privacidad
            </Link>{" "}
          </Typography>
        </>
      );
    }

    if (typeCompany === "finbe") {
      return (
        <>
          <Typography variant={"body2"} color={theme?.palette?.primary?.dark}>
            Autorizo a Financiera Bepensa SA DE CV SOFOM ER, Bepensa Leasing, SA DE CV, AB&C Leasing de México, SAPI DE
            CV y a Lendit Group SAPI de CV a consultar mi información ante Buró Empresas.
          </Typography>
        </>
      );
    }
  };

  const getTextAvisoPrivacidadTerminosBuro2 = (typeCompany: string) => {
    if (typeCompany === "lendia") {
      return <></>;
    }

    if (typeCompany === "finbe") {
      return (
        <>
          <Typography variant={"body2"} color={theme?.palette?.primary?.dark}>
            Consulta{" "}
            <Link href={interfaceConfigV2?.url_terms_and_conditions} target="_blank">
              términos y condiciones
            </Link>{" "}
            y{" "}
            <Link href={interfaceConfigV2?.url_privacy_notice} target="_blank">
              aviso de privacidad
            </Link>{" "}
          </Typography>
        </>
      );
    }
  };

  const getTextConfirmAval = () => {
    return (
      <>
        {interfaceConfig?.text_accionista_check ||
          "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud."}
      </>
    );
  };

  const getTextNipBuro = () => {
    const companyNames = interfaceConfig?.companyNames ?? [];
    const formattedCompanies = formatCompanyList(companyNames, false);

    if (application.tax_system_type === TAX_SYSTEM_TYPE.PM.code) {
      return (
        <>
          <Typography textAlign={"center"} color={theme?.palette?.primary?.dark}>
            <span>
              <small>
                Realizaremos una evaluación que nos determinará la factibilidad de poder acceder a financiamiento. Al
                continuar, el solicitante forma una relación jurídica como cliente de {formattedCompanies} y las
                autoriza a realizar consultas y evaluar información por mecanismos digitales.
              </small>
            </span>
          </Typography>
        </>
      );
    } else if (application.tax_system_type === TAX_SYSTEM_TYPE.PFAE.code) {
      return (
        <>
          <Typography textAlign={"center"} color={theme?.palette?.primary?.dark}>
            <span>
              <small>
                Realizaremos una evaluación que nos determinará la factibilidad de poder acceder a financiamiento. Al
                continuar, el solicitante forma una relación jurídica como cliente de {formattedCompanies} y las
                autoriza a realizar consultas y evaluar información por mecanismos digitales.
              </small>
            </span>
          </Typography>
        </>
      );
    } else if (application.tax_system_type === TAX_SYSTEM_TYPE.PF.code) {
      return (
        <>
          <Typography textAlign={"center"} color={theme?.palette?.primary?.dark}>
            <span>
              <small>
                Realizaremos una evaluación que nos determinará la factibilidad de poder acceder a financiamiento. Al
                continuar, el solicitante forma una relación jurídica como cliente de {formattedCompanies} y lo autoriza
                a realizar consultas y evaluar información por mecanismos digitales.
              </small>
            </span>
          </Typography>
        </>
      );
    }
  };

  const getTextNipBuroConfirm = () => {
    const companyNames = interfaceConfig?.companyNames ?? [];
    const formattedCompanies = formatCompanyList(companyNames, false);

    if (application.tax_system_type === TAX_SYSTEM_TYPE.PM.code) {
      return (
        <>
          Por este conducto autorizo expresamente a {formattedCompanies} para que por conducto de sus funcionarios{" "}
          facultados lleve a cabo investigaciones sobre mi comportamiento crediticio o el de la Empresa que represento
          en Dun & Bradstreet, S.A. SIC.
          <br />
          <br />
          Así mismo, declaro que conozco la naturaleza y alcance de la información que se solicitará, del uso que{" "}
          {formattedCompanies} hará de tal información y de que ésta podrá realizar consultas periódicas de mi historial
          crediticio, consintiendo que esta autorización se encuentre vigente por un periodo de 3 años contados a partir
          de la fecha de su expedición y en todo caso durante el tiempo que mantengamos relación jurídica.
        </>
      );
    } else if (application.tax_system_type === TAX_SYSTEM_TYPE.PFAE.code) {
      return (
        <>
          Por este conducto autorizo expresamente a {formattedCompanies} para que por conducto de sus funcionarios{" "}
          facultados lleve a cabo investigaciones sobre mi comportamiento crediticio o el de la Empresa que represento
          en Dun & Bradstreet, S.A. SIC.
          <br />
          <br />
          Así mismo, declaro que conozco la naturaleza y alcance de la información que se solicitará, del uso que{" "}
          {formattedCompanies} hará de tal información y de que ésta podrá realizar consultas periódicas de mi historial
          crediticio, consintiendo que esta autorización se encuentre vigente por un periodo de 3 años contados a partir
          de la fecha de su expedición y en todo caso durante el tiempo que mantengamos relación jurídica.
        </>
      );
    } else if (application.tax_system_type === TAX_SYSTEM_TYPE.PF.code) {
      return (
        <>
          Por este conducto autorizo expresamente a {formattedCompanies}
          para que por conducto de sus funcionarios facultados lleve a cabo investigaciones, sobre mi comportamiento
          crediticio en Trans Union de México, S. A. SIC.
          <br />
          <br />
          Así mismo, declaro que conozco la naturaleza y alcance de la información que se solicitará, del uso que Lendit
          Group SAPI hará de tal información y de que ésta podrá realizar consultas periódicas de mi historial
          crediticio, consintiendo que esta autorización se encuentre vigente por un periodo de 3 años contados a partir
          de la fecha de su expedición y en todo caso durante el tiempo que mantengamos relación jurídica.
        </>
      );
    }
  };

  return (
    <>
      {type === "textCiec" && <>{getTextCiec()}</>}
      {type === "modalCiec" && <>{getTextModalCiec()}</>}
      {type === "avisoTerminosTextCiec" && <>{getTextAvisoPrivacidadTerminos()}</>}
      {type === "avisoTerminosTextCiec2" && <>{getTextAvisoPrivacidadTerminos2()}</>}
      {type === "textBuro" && <>{getTextAvisoPrivacidadTerminosBuro(company)}</>}
      {type === "modalBuro" && <>{getTextModalBuro(company)}</>}
      {type === "avisoTerminosTextBuro" && <>{getTextAvisoPrivacidadTerminosBuro2(company)}</>}
      {type === "confirmAval" && <>{getTextConfirmAval()}</>}
      {type === "nipBuro" && <>{getTextNipBuro()}</>}
      {type === "nipBuroConfirm" && <>{getTextNipBuroConfirm()}</>}
    </>
  );
};
